package com.essntl.uikit.components.button.tinted

import androidx.compose.foundation.interaction.MutableInteractionSource
import androidx.compose.material3.MaterialTheme
import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember
import androidx.compose.ui.Modifier
import com.essntl.uikit.components.button.EsButton
import com.essntl.uikit.components.button.EsButtonColors
import com.essntl.uikit.components.button.EsButtonSize
import com.essntl.uikit.theme.EsColorScheme
import com.essntl.uikit.theme.esColorScheme

@Composable
fun EsLargeTintedButton(
    onClick: () -> Unit,
    text: String,
    prefixIconRes: String? = null,
    suffixIconRes: String? = null,
    enabled: Boolean = true,
    loading: Boolean = false,
    interactionSource: MutableInteractionSource = remember { MutableInteractionSource() },
    modifier: Modifier = Modifier,
) {
    val essntlColorScheme = MaterialTheme.esColorScheme

    EsButton(
        onClick = onClick,
        size = EsButtonSize.Large,
        colors = getTintedButtonColors(essntlColorScheme),
        text = text,
        prefixIconRes = prefixIconRes,
        suffixIconRes = suffixIconRes,
        enabled = enabled,
        loading = loading,
        interactionSource = interactionSource,
        modifier = modifier,
    )
}

internal fun getTintedButtonColors(esColorScheme: EsColorScheme) = EsButtonColors(
    containerColor = esColorScheme.tinted,
    disabledContainerColor = esColorScheme.tintedDisabled,
    pressedContainerColor = esColorScheme.tintedPressed,
    hoveredContainerColor = esColorScheme.tintedHover,
    focusedContainerColor = esColorScheme.tinted,
    textColor = esColorScheme.textAccent,
    disabledTextColor = esColorScheme.textDisabled,
    iconColor = esColorScheme.iconAccent,
    disabledIconColor = esColorScheme.iconDisabled,
    borderFocusColor = esColorScheme.borderFocus,
)